import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';

export const PortalLinearProgress = ({ value, ...props }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" {...props} value={value} />
      </Box>
      <Box>
        <Typography variant="body2">{`${Math.round(value)}%\u00A0Complete`}</Typography>
      </Box>
    </Box>
  );
};
